import CustomNavLinkProps from "../../services/models/customTabProps.model";
import CustomNavLink from "../molecular/CustomTab";

function Tabs({ tabs, containerClassName }: { tabs: CustomNavLinkProps[], containerClassName?: string }): JSX.Element {
  return <div className={`bg-sideNavGray rounded-lg p-4 h-[51px] mx-5 my-6 flex w-[300px] items-center border border-roundedInputBorder ${containerClassName}`}>
    {tabs.map((tab) => <CustomNavLink key={tab.to} {...tab} className="mr-4" />)}
  </div>
}

export default Tabs;